import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminTable from 'common/AdminTable';
import TruncatedMessage from 'common/TruncatedMessage';
import { getRequest, deleteRequest } from 'apis/ApiInstence';
import { FaTrash, FaEdit } from 'react-icons/fa';

const TestimonialList = () => {
  const [testimonialData, setTestimonialData] = useState([]);
  const navigate = useNavigate();

  const fetchTestimonials = async () => {
    try {
      const res = await getRequest('testimonials');
      setTestimonialData(res?.data || []);
    } catch (err) {
      console.error('Failed to fetch testimonials:', err);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const handleRemove = async (id) => {
    if (!window.confirm('Are you sure you want to delete this testimonial?')) return;
    try {
      await deleteRequest(`testimonials/${id}`);
      fetchTestimonials();
    } catch (err) {
      console.error('Failed to delete testimonial:', err);
    }
  };

  const tableHeaders = [
    { Header: 'Name', accessor: 'name' },
    { Header: 'Rating', accessor: 'rating' },
    { Header: 'Status', accessor: 'status' },
    {
      Header: 'Message',
      accessor: 'message',
      Cell: ({ row }) => <TruncatedMessage text={row?.original?.message} maxLength={10} />
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#ffc107' }}
            onClick={() => navigate(`/testimonials/update/${row.original.id}`)}
          >
            <FaEdit />
          </button>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#dc3545' }}
            onClick={() => handleRemove(row.original.id)}
          >
            <FaTrash />
          </button>
        </>
      )
    }
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Testimonial List</h4>
      </div>
      <div className="mx-4">
        {testimonialData?.length ? (
          <AdminTable tableHeaders={tableHeaders} tableData={testimonialData} />
        ) : (
          <p>No testimonials available.</p>
        )}
      </div>
    </div>
  );
};

export default TestimonialList;
